.sourcePill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: var(--light-grey);
  color: #535bf2;
  padding: 1px 7px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid rgba(83, 91, 242, 0.4);
  transition: all 0.2s ease;
  cursor: pointer;
  line-height: 1.2;
  transform: translateY(-1px);
  vertical-align: middle;
}

.sourcePill:hover {
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sourcePillCompleted {
  background-color: rgba(76, 175, 80, 0.1);
  border-color: var(--button-success-color);
  color: var(--button-success-color);
}

.sourcePillNew {
  background-color: transparent;
  border-color: var(--main-blue);
  color: var(--main-blue);
}

.sourcePillPending {
  background-color: transparent;
  border-color: #ff9800;
  color: #ff9800;
}

.sourcePillFailed {
  background-color: rgba(255, 153, 128, 0.2);
  border-color: #d32f2f;
  color: #d32f2f;
}

.sourcePillDefault {
  background-color: var(--light-purple);
  border-color: rgba(121, 97, 219, 0.35);
  color: var(--purple);
}

.sourcePill:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(121, 97, 219, 0.1);
}

/* Tooltip styles */
.tooltip {
  background-color: var(--main-background) !important;
  padding: 0 !important;
  border-radius: 0 !important;
  max-width: 320px !important;
  margin-top: -8px !important;
}

.tooltipCard {
  background-color: var(--main-background);
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 300px;
  border: 1px solid var(--box-border-color);
}

.tooltipHeadline {
  font-size: 16px;
  font-weight: 700;
  color: var(--main-text);
  margin-bottom: 8px;
  line-height: 1.3;
}

.tooltipMetadata {
  font-size: 12px;
  color: var(--body-text);
  margin-bottom: 12px;
  line-height: 1.2;
}

.tooltipDate {
  color: var(--body-text);
}

.tooltipSeparator {
  color: var(--body-text);
}

.tooltipSource {
  color: var(--body-text);
}

.tooltipSnippet {
  font-size: 14px;
  color: var(--main-text);
  line-height: 1.4;
  margin-bottom: 16px;
}

.tooltipActions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.tooltipButton {
  flex: 1;
  display: flex;
  justify-content: center;
}

.actionLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: var(--body-text);
  transition: color 0.2s ease;
}

.actionLink:hover {
  color: var(--main-text);
}

.actionButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  color: var(--body-text);
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;
}

.actionButton:hover:not(:disabled) {
  color: var(--main-text);
}

.actionButton:disabled {
  color: var(--muted-text);
  cursor: not-allowed;
}

.actionIcon {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionLabel {
  font-size: 11px;
  font-weight: 500;
  text-align: center;
}

.comingSoonLabel {
  font-size: 9px;
  font-weight: 400;
  text-align: center;
  color: var(--muted-text);
  margin-top: 2px;
}

.requestStatus {
  margin: 8px 0;
  padding: 6px 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  border-left: 3px solid var(--purple);
}

.requestDate {
  font-size: 10px;
  color: var(--muted-text);
  margin-top: 2px;
}

/* Status-specific styles */
.statusNew {
  color: #535bf2;
  font-weight: 500;
}

.statusPending {
  color: #ffa726;
  font-weight: 500;
}

.statusDone {
  color: #66bb6a;
  font-weight: 500;
}

.statusFailed {
  color: #ef5350;
  font-weight: 500;
}

/* Toast button styles */
.toastRetryButton {
  background-color: var(--status-error) !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.toastRetryButton:hover {
  background-color: #d32f2f !important;
}

.toastViewResultsButton {
  background-color: var(--button-success-color) !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.toastViewResultsButton:hover {
  background-color: var(--button-success-pseudo-color) !important;
}

.completedButton {
  background-color: var(--button-success-color) !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.completedButton:hover {
  background-color: var(--button-success-pseudo-color) !important;
}

/* Toast snackbar styles */
.toastSnackbar {
  margin-bottom: 16px;
  margin-left: 16px;
}

.toastAlert {
  min-width: 300px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
}

.toastAlert .MuiAlert-icon {
  color: inherit;
}

.toastAlert .MuiAlert-action {
  color: inherit;
}

/* Status Icons */
.statusIcon {
  font-size: 9px !important;
  width: 9px !important;
  height: 9px !important;
}

.statusPending {
  color: #ff9800 !important; /* Orange for pending requests */
}

.statusNew {
  color: var(--main-blue) !important; /* Blue for new requests */
}

.statusDone {
  color: var(
    --button-success-color
  ) !important; /* Green for successful completion */
}

.statusFailed {
  color: #f44336 !important; /* Red for failed requests */
}

/* Animation for source pills with open analysis */
@keyframes pulseAnalysis {
  0% {
    box-shadow: 0 2px 8px rgba(121, 97, 219, 0.4);
  }
  50% {
    box-shadow:
      0 2px 8px rgba(121, 97, 219, 0.4),
      0 0 0 4px rgba(121, 97, 219, 0.2);
  }
  100% {
    box-shadow: 0 2px 8px rgba(121, 97, 219, 0.4);
  }
}
